import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import {TreeModule} from 'primeng/tree';
import {TreeNode} from 'primeng/api';

@Injectable()
export class TreeService {

  constructor(private http: Http) {}

    getFiles() {
      var json = '[{"label": "Documents","data": "Documents Folder","expandedIcon": "","collapsedIcon": "","children": [{"label": "Work","data": "Work Folder","expandedIcon": "fa-folder-open","collapsedIcon": "fa-folder","children": [{"label": "Expenses.doc", "icon": "fa-file-word-o", "data": "Expenses Document"}, {"label": "Resume.doc", "icon": "fa-file-word-o", "data": "Resume Document"}]},{"label": "Home","data": "Home Folder","expandedIcon": "fa-folder-open","collapsedIcon": "fa-folder","children": [{"label": "Invoices.txt", "icon": "fa-file-word-o", "data": "Invoices for this month"}]}]},{"label": "Pictures","data": "Pictures Folder","expandedIcon": "fa-folder-open","collapsedIcon": "fa-folder","children": [{"label": "barcelona.jpg", "icon": "fa-file-image-o", "data": "Barcelona Photo"},{"label": "logo.jpg", "icon": "fa-file-image-o", "data": "PrimeFaces Logo"},{"label": "primeui.png", "icon": "fa-file-image-o", "data": "PrimeUI Logo"}]},{"label": "Movies","data": "Movies Folder","expandedIcon": "fa-folder-open","collapsedIcon": "fa-folder","children": [{"label": "Al Pacino","data": "Pacino Movies","children": [{"label": "Scarface", "icon": "fa-file-video-o", "data": "Scarface Movie"}, {"label": "Serpico", "icon": "fa-file-video-o", "data": "Serpico Movie"}]},{"label": "Robert De Niro","data": "De Niro Movies","children": [{"label": "Goodfellas", "icon": "fa-file-video-o", "data": "Goodfellas Movie"}, {"label": "Untouchables", "icon": "fa-file-video-o", "data": "Untouchables Movie"}]}]}]' ;
        return JSON.parse(json);
    }

}


@Injectable()
export class NodeService {

    
}


// WEBPACK FOOTER //
// /media/tranhien/34DCFEAFDCFE6B0E/SourceCode/AMISS4/AMISS4_PC1_LINUX/src/app/services/common/tree.service.ts